export var MessageSeverity;
(function (MessageSeverity) {
    MessageSeverity[MessageSeverity["Critical"] = "critical"] = "Critical";
    MessageSeverity[MessageSeverity["Warning"] = "warning"] = "Warning";
    MessageSeverity[MessageSeverity["Informational"] = "informational"] = "Informational";
})(MessageSeverity || (MessageSeverity = {}));
export class Message {
    constructor(message) {
        this.id = message && message.id || null;
        this.severity = message && message.severity || null;
        this.title = message && message.title || null;
        this.value = message && message.value || null;
    }
}
//# sourceMappingURL=message.model.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fedelta-pos/data-client/messaging/message.model.js
// module id = null
// module chunks = 